module.exports = __webpack_public_path__ + "img/finish_btn.ccb65a64.png";